const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://apicabaza.creago.be/rest/cabaza';
// Clé d'API des lectures protégées.
//
// ELLE N'EST PAS SECRÈTE : toute variable `VITE_*` part en clair dans le bundle
// servi au navigateur. Elle écarte l'appel anonyme depuis l'extérieur, rien de
// plus — et ce qu'elle garde ici n'est que de la lecture publique.
//
// Pas de repli en dur : une clé absente doit se voir, pas se remplacer
// silencieusement par une valeur d'exemple que porte le dépôt.
const DEFAULT_API_KEY = import.meta.env.VITE_API_KEY;

function headers() {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': DEFAULT_API_KEY
    };
}

export const getActiveFaq = async (lang = 'fr', category = '') => {
    const qs = new URLSearchParams({ lang });
    if (category) qs.set('category', category);
    const res = await fetch(`${API_BASE_URL}/faq/active?${qs.toString()}`, {
        method: 'GET',
        headers: headers()
    });
    const data = await res.json();
    return data.data || data.DATA || [];
};
